<template>
  <div class="row">
    <div class="col-12 c g">
        <div class="card card-body">
            <div class="row">
                <div class="col-12 col-lg-2">
                    <div class="form-group">
                    <label for="">من تاريخ</label>
                    <input type="date"
                        class="form-control" v-model="from" id="from">
                    </div>
                </div>
                <div class="col-12 col-lg-2">
                    <div class="form-group">
                    <label for="">الى تاريخ</label>
                    <input type="date"
                        class="form-control" v-model="to" id="to">
                    </div>
                </div>
                <div class="col-12 col-lg-2">
                    <div class="form-group">
                        <label>نوع المسائلة</label>
                        <select class="form-control" v-model="type">
                            <option value="all">الكل</option>
                            <option value="ghiab">مسائلة غياب</option>
                            <option value="late">مسائلة تأخر</option>
                            <option value="out_early">مسائلة انصراف</option>
                            <option value="dis">قرار حسم غياب</option>
                            <option value="latedis">قرار حسم ساعات</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-lg-2">
                    <div class="form-group">
                        <label>حالة الرد</label>
                        <select class="form-control" v-model="reply_status">
                            <option value="all">الكل</option>
                            <option value="replied">تم الرد</option>
                            <option value="not_replied">لم يتم الرد</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-lg-2">
                    <div class="form-group">
                    <label for="">بحث</label>
                    <input type="text"
                        class="form-control" placeholder="اسم او رقم..." v-model="q">
                    </div>
                </div>
                <div class="col-12 col-lg-2 text-center">
                    <br>
                    <button class="btn btn-success" @click="getAsks()" v-if="!loading">
                        <i class="fa fa-search"></i>
                        عرض
                    </button>
                    <button class="btn btn-primary disabled" disabled v-if="loading">
                        جاري البحث...
                    </button>
                </div>
                <div class="col-12 row" v-if="asks.length">
                    <div class="col-12 col-lg-2">
                        <br>
                        <button @click="print()" class="btn btn-secondary btn-block">
                            <i class="fa fa-print"></i>
                            طباعة
                        </button>
                    </div>
                    <div class="col-12 col-lg-2">
                        <br>
                        <button @click="exportExcel()" class="btn btn-success btn-block">
                            <i class="fa fa-file"></i>
                            تصدير
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 g" v-if="!loading">
        <div class="card card-body">
            <div class="col-12 table-responsive">
                <table class="table table-hover table-bordered table-sm table-striped" id="table">
                    <thead>
                        <th>م</th>
                        <th>المعلم</th>
                        <th>الرقم الوظيفي</th>
                        <th>النوع</th>
                        <th>التاريخ</th>
                        <th>حالة الرد</th>
                        <th>رد المعلم</th>
                        <th class="hideme">اجراء</th>
                    </thead>
                    <tbody>
                        <tr v-for="(ask, i) in filteredAsks" :key="ask._id">
                            <td>{{ i+1 }}</td>
                            <td>{{ ask.teacher_name }}</td>
                            <td>{{ ask.number }}</td>
                            <td>{{ formatType(ask.type) }}</td>
                            <td>{{ ask.date }}</td>
                            <td>
                                <span class="badge bg-success" v-if="ask.teacher_reply != null">تم الرد</span>
                                <span class="badge bg-danger" v-else>لم يتم الرد</span>
                                &nbsp;
                                <span class="badge bg-info" v-if="ask.teacher_signature">تم التوقيع</span>
                            </td>
                            <td>
                                <span v-if="ask.teacher_reply">{{ ask.teacher_reply }}</span>
                                <span v-else class="text-muted">-</span>
                                <div v-if="ask.teacher_signature" style="margin-top: 5px;">
                                    <img :src="ask.teacher_signature" style="max-width: 150px; border: 1px solid #eee; border-radius: 3px;">
                                </div>
                            </td>
                            <td class="hideme">
                                <a :href="`https://s.tahdir.net/teacher-ask/${ask._id}`" target="_blank" class="btn btn-sm btn-primary">
                                    <i class="fa fa-eye"></i> عرض
                                </a>
                                <button class="btn btn-sm btn-danger" @click="deleteAsk(ask._id)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
var XLSX = require("xlsx");
export default {
    data(){
        return {
            loading: false,
            asks: [],
            user: JSON.parse(localStorage.getItem('user')),
            from: start_date,
            to: new Date().toISOString().split("T")[0],
            type: 'all',
            reply_status: 'all',
            q: null,
            types: {
                "ghiab": "مسائلة غياب",
                "late": "مسائلة تأخر",
                "out_early": "مسائلة انصراف",
                "dis": "قرار حسم غياب",
                "latedis": "قرار حسم ساعات",
                "other-0": "عدم تواجد داخل الفصل",
                "other-1": "خروج من الحصة قبل انتهاء الوقت",
                "other-2": "عدم تحضير الدروس",
                "other-3": "عدم المناوبة في الفسحة",
                "other-4": "عدم المناوبة في الممرات",
                "other-5": "عدم المناوبة في نهاية الدوام",
                "other-6": "عدم الحضور لحصص الانتظار"
            }
        }
    },
    computed: {
        filteredAsks(){
            var g = this;
            if(!g.q || g.q == ""){
                return g.asks;
            }
            return g.asks.filter(function(a){
                return a.teacher_name?.includes(g.q) || a.number?.includes(g.q)
            })
        }
    },
    created(){
        if(!checkPer("teachers|reports|asks-all")){
            this.$router.push('/NotPermitted')
            return false;
        }
        this.getAsks()
    },
    methods: {
        formatType(type){
            return this.types[type] ?? type;
        },
        getAsks(){
            var g = this;
            g.loading = true;
            $.post(api + '/user/teachers/asks/all', {
                jwt: this.user.jwt,
                from: g.from,
                to: g.to,
                type: g.type,
                reply_status: g.reply_status
            }).then(function(r){
                g.loading = false;
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.asks = r.response;
                }
            }).fail(function(){
                g.loading = false;
            })
        },
        deleteAsk(id){
            var g = this;
            if(!confirm("هل أنت متأكد من حذف هذه المسائلة؟")) return;
            $.post(api + '/user/teachers/reports/delete-ask', {
                jwt: this.user.jwt,
                id: id
            }).then(function(r){
                if(r.status == 100){
                    g.getAsks();
                }else{
                    alert(r.response)
                }
            })
        },
        exportExcel(){
            const wb = XLSX.utils.book_new(), g = this;
            const Heading = [[
                "م", "المعلم", "الرقم الوظيفي", "النوع", "التاريخ", "حالة الرد", "رد المعلم"
            ]];
            var xx = [];
            g.filteredAsks.forEach(function(a, i){
                xx.push([
                    i+1,
                    a.teacher_name,
                    a.number,
                    g.formatType(a.type),
                    a.date,
                    a.teacher_reply != null ? "تم الرد" : "لم يتم الرد",
                    a.teacher_reply ?? ""
                ])
            })
            const ws = XLSX.utils.json_to_sheet(xx, { origin: 'A2', skipHeader: true });
            XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
            XLSX.utils.book_append_sheet(wb, ws, 'Records');
            XLSX.utils.writeFile(wb, "المسائلات.xlsx");
        },
        print(){
            var g = this;
            var win = window.open("", "")
            win.document.write(`
            <html dir='rtl'>
                <head>
                    <style>
                        table, td, th { border: 1px solid; }
                        tr { text-align: center }
                        table { width: 100%; border-collapse: collapse; }
                        th { background: #eee }
                        .hideme, button { display:none }
                    </style>
                </head>
                <body>
                    <center><h3>جميع المسائلات من ${g.from} الى ${g.to}</h3></center>
                    ${$("#table").parent().html()}
                </body>
            </html>
            `)
            win.document.close()
            setTimeout(() => { win.print() }, 1000);
        }
    }
}
</script>
